import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiConfirmUserDeleteDialogComponent } from './fi-confirm-user-delete-dialog.component';
import { FiAppTextSharedModule } from '../app-text';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, MatFormFieldModule, MatInputModule, FormsModule],
    declarations: [FiConfirmUserDeleteDialogComponent],
    exports: [FiConfirmUserDeleteDialogComponent],
})
export class FiConfirmUserDeleteDialogComponentModule {}
